// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1aKKx","hidden":"_2J8mo"};